var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 84,
    viewBox: "0 0 63 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2145 0H4.77534C2.60616 0 0.850586 1.53859 0.850586 3.43968C0.850586 5.34882 2.60616 6.88741 4.77534 6.87935H58.2145C60.3837 6.87935 62.1393 5.34076 62.1393 3.43968C62.1393 1.53859 60.3837 0 58.2145 0ZM11.4904 9.89361H52.2453C54.8925 9.89361 56.4734 12.4714 55.0028 14.4047L36.3717 38.8771C36.3035 38.9668 36.2381 39.0535 36.175 39.1374L36.1749 39.1376C35.4208 40.1389 34.9761 40.7293 33.6786 40.9151V38.8127C34.45 38.6665 34.6644 38.3361 35.0052 37.8111C35.1151 37.6418 35.2382 37.4521 35.3974 37.2419L40.9582 29.9356C38.1456 29.5167 35.0849 29.275 31.8679 29.275C28.6509 29.275 25.5809 29.5167 22.7775 29.9356L28.3383 37.2419C28.4715 37.4169 28.5843 37.578 28.6873 37.725C29.1245 38.3491 29.3851 38.721 30.2777 38.8449V40.9474C28.8125 40.7878 28.3025 40.115 27.3914 38.9132L27.3641 38.8771L8.73296 14.4047C7.26233 12.4794 8.84326 9.89361 11.4904 9.89361ZM58.2145 83.9998H4.77534C2.60616 83.9998 0.850586 82.4612 0.850586 80.5601C0.850586 78.659 2.60616 77.1204 4.77534 77.1204H58.2145C60.3837 77.1204 62.1393 78.659 62.1393 80.5601C62.1393 82.4612 60.3837 83.9998 58.2145 83.9998ZM37.8278 46.7197L54.6298 68.7836C56.1004 70.7089 54.5195 73.2947 51.8723 73.2947H11.1174C8.47024 73.2947 6.88931 70.7169 8.35995 68.7836L25.1619 46.7197C26.5315 44.9314 27.7264 43.9567 29.9047 43.7876V59.8582C24.013 59.9146 19.5092 60.704 15.18 62.009L10.7313 67.8572C9.40777 69.5892 10.8324 71.9091 13.2038 71.9091H49.7767C52.1481 71.9091 53.5635 69.5892 52.2492 67.8572L47.8005 62.009C43.5265 60.7201 39.1054 59.9307 33.2964 59.8582V43.7956C35.4012 44.0051 36.5042 44.9798 37.8278 46.7197Z",
    fill: "url(#paint0_linear_5819_9994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5819_9994",
    x1: 31.4949,
    y1: -2,
    x2: 31.4949,
    y2: 83.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BE1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass_icon.72cda7501b9f67056664f3ae57a6aaf7.svg";
export { ForwardRef as ReactComponent };